export default function (value) {
    if (value <= 999) {
        return value
    } else if (value <= 999999) {
        return parseFloat((value/1000).toFixed(1)) + 'K'
    } else {
        return parseFloat((value/1000000).toFixed(2)) + 'M'
    }
}